module.exports = __webpack_public_path__ + "img/info-icon.3f4bf1db.svg";